module.exports = __webpack_public_path__ + "img/home_02.da12a902.png";